import InfiniteScroll from 'react-infinite-scroll-component'
import { Link } from 'react-router-dom'
import { useSamplePacks } from '../../../queries/samplePacks'
import Button from '../../core/Button/Button'
import CenteredLoadingAnimation from '../../core/CenteredLoadingAnimation'
import { Spacer } from '../../core/Components'
import { Flex } from '../../core/Flex'
import Text from '../../core/Text/Text'
import { InternalEndpoint } from '../../Internal'
import { TableHeader, TableRow, TableText } from '../components/common'

export const SamplePacksTableHeader = () => (
  <TableRow>
    <TableHeader>Title</TableHeader>
    <TableHeader>Artist</TableHeader>
    <TableHeader>Sound Count</TableHeader>
  </TableRow>
)

export const SamplePacks = () => {
  const samplePacksQuery = useSamplePacks({ params: { perPage: 25, order: 'desc' } })

  return (
    <>
      <Flex>
        <Text size="24" css={{ marginBottom: '$16' }}>
          Sample Packs
        </Text>
        <Spacer />
        <Link to={`/${InternalEndpoint}/sample-packs/create`}>
          <Button type="dark" big>
            Add Sample Pack
          </Button>
        </Link>
      </Flex>
      <SamplePacksTableHeader />
      {samplePacksQuery.isLoading && <CenteredLoadingAnimation />}
      {!samplePacksQuery.isLoading && (
        <InfiniteScroll
          loader={<CenteredLoadingAnimation />}
          dataLength={samplePacksQuery.data?.pages.length * 50}
          next={samplePacksQuery.fetchNextPage}
          hasMore={samplePacksQuery.hasNextPage}
          style={{ overflow: 'visible' }}
        >
          {samplePacksQuery.data.pages.map((page) =>
            page.data.map((samplePack) => (
              <Link key={samplePack.id} to={`/${InternalEndpoint}/sample-packs/${samplePack.id}`}>
                <TableRow hover>
                  <TableText>{samplePack.title}</TableText>
                  <TableText>{samplePack.user.displayName}</TableText>
                  <TableText>{samplePack.soundCount}</TableText>
                </TableRow>
              </Link>
            ))
          )}
        </InfiniteScroll>
      )}
    </>
  )
}
